import { type FC } from "react";

import { Progress, Stack } from "@mantine/core";
import { useIntl } from "react-intl";

import { formatMilliUsd } from "../../../lens-creator-payout/utils/formatMilliUsd";
import { formatWithUSFormat } from "../../../lens-stats/formatters/formatNumbers";
import { type TopPerformerLensRow, TopPerformerLensStatus } from "../../models";
import { posterProgressPercent } from "../../utils";

import { award, noAward, posters, progress, progressBar } from "./TopPerformerLensTable.module.css";
import { NoAward, PostersCount, PostersProgress, PostersUnavailable, messages } from "./messages.generated";

export const PostersCell: FC<{ row: TopPerformerLensRow }> = ({ row }) => {
    const intl = useIntl();
    if (row.qualifiedPosters === null || row.qualifiedPosters === undefined) {
        return (
            <span className={`paragraph-p200 ${posters}`}>
                <PostersUnavailable />
            </span>
        );
    }
    const qualified = formatWithUSFormat(row.qualifiedPosters);
    if (row.status !== TopPerformerLensStatus.InWindow) {
        return (
            <span className={`paragraph-p200 ${posters}`}>
                <PostersCount qualified={qualified} />
            </span>
        );
    }
    const percent = posterProgressPercent(row.qualifiedPosters, row.postersThreshold);
    return (
        <Stack gap="xs">
            <span className={`paragraph-p200 ${posters}`}>
                <PostersProgress qualified={qualified} threshold={formatWithUSFormat(row.postersThreshold)} />
            </span>
            <Progress
                value={percent}
                size="sm"
                radius="xl"
                classNames={{ root: progress, section: progressBar }}
                aria-label={intl.formatMessage(messages.postersProgressLabel)}
            />
        </Stack>
    );
};

export const AwardCell: FC<{ row: TopPerformerLensRow }> = ({ row }) =>
    row.status === TopPerformerLensStatus.Awarded && row.award ? (
        <span className={`heading-h600 ${award}`}>{formatMilliUsd(row.award.amountMilliUsd)}</span>
    ) : (
        <span className={`paragraph-p200 ${noAward}`}>
            <NoAward />
        </span>
    );
